// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1Grz5","content":"LoadingAlert_content__2q5NP"};